module.exports = __webpack_public_path__ + "img/a7c9883.png";